const Search = ({ ...props }) => {
    return (
        <svg width="14" height="15" viewBox="0 0 14 15" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1.36957 5.92665C1.36957 3.40707 3.419 1.36477 5.94733 1.36477C8.47571 1.36477 10.5254 3.40712 10.5254 5.92665C10.5254 8.44618 8.47571 10.4885 5.94733 10.4885C3.419 10.4885 1.36957 8.44623 1.36957 5.92665ZM5.94733 0C2.66256 0 0 2.65337 0 5.92665C0 9.19993 2.66256 11.8533 5.94733 11.8533C7.07187 11.8533 8.12353 11.5423 9.02041 11.0019C9.02736 11.0095 9.0345 11.0169 9.04185 11.0243L12.831 14.8001C13.0984 15.0666 13.532 15.0666 13.7994 14.8001C14.0669 14.5336 14.0669 14.1016 13.7994 13.8351L10.1106 10.1592C11.2118 9.08358 11.895 7.58465 11.895 5.92665C11.895 2.65331 9.23204 0 5.94733 0Z"
                fill="#EE6C4D"
            />
        </svg>
    )
}

export default Search
